export default __webpack_public_path__ + "static/media/B_wdt_c_cap_0.19eb50c0.mp3";